import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";

export class InventoryStart extends ListComponent {
    protected location: string | null = null;
    protected inventoryId: number | null = null;

    locationRef: React.RefObject<HTMLInputElement>;
    barcodeRef: React.RefObject<HTMLInputElement>;

    constructor(props: {}) {
        super(props);
        this.locationRef = React.createRef();
        this.barcodeRef = React.createRef();

        this.closeInventory = this.closeInventory.bind(this);
        this.cancelInventory = this.cancelInventory.bind(this);
    }

    protected getRequestUrl(): RequestInfo | URL {
        if (this.inventoryId === null) {
            return `/inventory/start`;
        }
        if (this.location === null) {
            return `/inventory/init/${this.inventoryId}/`;
        }
        return `/inventory/add/${this.inventoryId}`;
    }

    protected afterSetStateFinished() {

        const location = document.querySelector(
            'form.x-form #location'
        ) as HTMLInputElement | null;

        const barcode = document.querySelector(
            'form.x-form #barcode'
        ) as HTMLInputElement | null;

        if (barcode) {
            barcode.value = '';
            barcode.focus();
        } else if (location) {
            location.value = '';
            location.focus();
        }
    }

    renderInventoryStart() {
        if (!this.state) {
            return <Loader/>;
        }
        return (<>
            <div className="row">
                <h5 className="open-search">{this.dictionary.get['initialization']}</h5>
                <form className="x-form" method="POST" onSubmit={this.handleSubmit} id={'renderInventoryStart'}></form>
            </div>
        </>);
    }

    renderLocationInit() {
        if (!this.state) {
            return <Loader/>;
        }
        return (<>
                <div className="row">
                    <h5 className="open-search">{this.dictionary.get['location']}</h5>
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit} id={'renderLocationInit'}>
                        <div className="row">
                            <div className="col-md-12 col-lg-6 col-xl-4">
                                <FormGroup.Input {...{
                                    id: 'location',
                                    label: 'set-location',
                                    autoFocus: true,
                                    autoComplete: 'off',
                                    defaultValue: '',
                                    defaultRef: this.locationRef
                                }}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['submit']}
                                </button>
                                <button className="btn btn-sm btn-warning float-end" onClick={this.cancelInventory}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['cancel-inventory'])}
                                </button>
                                <button className="btn btn-sm btn-primary float-end" onClick={this.closeInventory}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['close-inventory'])}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                {this.listOfItems()}
            </>
        );
    }

    private closeInventory(e: any) {
        e.preventDefault();

        this.request.fetch(`/inventory/close/${this.inventoryId}`, null, {method: 'GET'}).catch(error => {
            this.onError(error);
            console.error(error);
            // @ts-ignore
            return this.request.response.json();
        }).then(e => {
            window.location.assign('/inventory/list')
        });

    }

    private cancelInventory(e: any) {
        e.preventDefault();

        this.request.fetch(`/inventory/cancel/${this.inventoryId}`, null, {method: 'GET'}).catch(error => {
            this.onError(error);
            console.error(error);
            // @ts-ignore
            return this.request.response.json();
        }).then(e => {
            window.location.assign('/inventory/list')
        });
    }

    private newLocation(e: any) {
        e.preventDefault();
        window.location.reload();
    }

    capitalizeFirstLetter(val: string) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    addProductInit() {
        if (!this.state) {
            return <Loader/>;
        }
        return (<>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['add-product']} - {this.location}
                    </h5>
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <div className="col-md-12 col-lg-6 col-xl-4">
                                <FormGroup.Input {...{
                                    id: 'barcode',
                                    label: 'set-barcode',
                                    autoFocus: true,
                                    autoComplete: 'off',
                                    defaultValue: '',
                                    defaultRef: this.barcodeRef
                                }}/>
                            </div>
                        </div>
                        <input type={'hidden'} name={'location'} id={'location'} value={this.location || ''}/>
                        <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['submit']}
                                </button>
                                <button className="btn btn-sm btn-info float-end" onClick={this.newLocation}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['new-location'])}
                                </button>
                                <button className="btn btn-sm btn-warning float-end" onClick={this.cancelInventory}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['cancel-inventory'])}
                                </button>
                                <button className="btn btn-sm btn-primary float-end" onClick={this.closeInventory}>
                                    {this.capitalizeFirstLetter(this.dictionary.get['close-inventory'])}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                {this.listOfItems()}
            </>
        );
    }

    listOfItems() {
        if (!this.state?.item?.items) {
            return ('');
        }
        return (<>
            <div className="row">
                <div className="table-responsive">
                    <table className="table table-hover table-sm align-middle">
                        <thead>
                        <tr>
                            <th className="sortable" data-sortkey="i.id">
                                #ID
                            </th>
                            <th className="sortable" data-sortkey="i.location">
                                {this.dictionary.get['location']}
                            </th>
                            <th className="sortable" data-sortkey="i.sku">
                                {this.dictionary.get['sku']}
                            </th>
                            <th className="sortable" data-sortkey="p.`name`">
                                {this.dictionary.get['product_name']}
                            </th>
                            <th className="sortable" data-sortkey="i.quantity">
                                {this.dictionary.get['quantity']}
                            </th>
                            <th className="sortable" data-sortkey="i.updated_at">
                                {this.dictionary.get['updated_at']}<i className="bi bi-sort-down"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.item.items.map(function (elem: any) {
                            return (
                                <tr key={elem.id + '-sku:' + elem.sku} data-id={elem.id}>
                                    <td align={'right'}>{elem.id}.</td>
                                    <td>{elem.location}</td>
                                    <td>{elem.sku}</td>
                                    <td>{elem.product_name}</td>
                                    <td>{elem.quantity}</td>
                                    <td><DateTime value={elem.updated_at} inline={true}/></td>
                                </tr>
                            )
                        })}
                        </tbody>
                        {/*{this.state.itemsCount < this.limit ? (*/}
                        <TableFooter colspan={7}/>
                        {/*) : ''}*/}
                    </table>
                    {/*{this.state.isLoading && <Loader/>}*/}
                </div>
            </div>
        </>);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }
        if (this.state?.item?.id) {
            this.inventoryId = this.state.item.id;
        }
        if (this.state?.item?.location) {
            this.location = this.state.item.location;
        }

        if (this.inventoryId === null) {
            return this.renderInventoryStart();
        }
        if (this.location === null) {
            return this.renderLocationInit();
        }

        return this.addProductInit();
    }

}
